<template>
  <aha-profanity-filter
    :text="text"
    :filteringProfanity="!!$store.state.presentation.filteringProfanity"
  />
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>
